import { useAppContext } from 'context/AppContext'
import { useState, useEffect } from 'react'
import Slider from 'react-slick'
import { CardItem } from './CardItem'
import Translation from 'components/Translation'
import { Testimonial } from 'components/Modals/Signup/TenantSignUp'
export const ClientCards = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: true,
        swipeToSlide: true,
        arrows: true,
        centerMode: true,
        centerPadding: '0px',
        cssEase: 'linear',
        className: 'center',
        // autoplaySpeed: 2000,
        // autoplay: true,

        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    centerMode: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    centerMode: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                },
            },
        ],
    }

    const [testimonies, setTestimonies] = useState<Testimonial[]>([])
    const { translations } = useAppContext()

    useEffect(() => {
        if (translations) {
            if (translations?.['testimonies']) {
                setTestimonies(JSON.parse(translations?.['testimonies']))
            }
        }
    }, [translations])

    const renderCards = (cards: Testimonial[]) => {
        return cards.map((item, index) => (
            <CardItem {...item} key={index} />
        ))
    }

    return (
        <div className="px-10 lg:px-[17%]" style={{ marginTop: '120px'}}>
            <div className="sm:w-3/4 mx-auto w-full">
                <h1 className=" text-5xl font-bold text-center  text-white circular_std">
                    <Translation content_key="landing.client_card_title" />
                </h1>
                <p className="text-white font-medium text-base leading-7 text-center  circular_std_light">
                    <Translation content_key="landing.client_card_desc" />
                </p>
            </div>
            <br></br>
            <div className="Card-Container">
                <Slider {...settings}>{renderCards(testimonies)}</Slider>
            </div>
        </div>
    )
}
